<template>
  <popConfirmButton
    :ok-text="$t('shang-jia')"
    :cancel-text="$t('qu-xiao')"
    class="card-btn-online"
    type="primary"
    @confirm="confirm"
  >
    <template #title>
      {{
        $t(
          'shang-jia-gai-mo-ban-hou-suo-you-yong-hu-jiang-ke-yi-cha-kan-shi-yong-que-ren-shi-fou-shang-jia-0'
        )
      }}
    </template>
    <template #default>
      {{ $t('shang-jia') }}
    </template>
  </popConfirmButton>
</template>

<script lang="ts" setup>
import popConfirmButton from './pop-confirm-button.vue'
import type { Template } from '~/api/interface'

const ctx: any = inject('personal-page-ctx')
const cardItem = inject<Template>('card-item')

const confirm = () => {
  cardItem ? ctx.actionToggleOnline(cardItem) : ctx.actionToggleOnline()
}
</script>

<style lang="scss">
.card-btn-online {
  flex: 1;
  border-radius: 6px;
}
</style>
